import { atom } from 'recoil';

export interface SystemCityItemInterface {
  code: number;
  id: number;
  lat: string;
  level: number;
  lng: string;
  mergerName: string;
  name: string;
  parentCode: number;
  areaCode: string;
  children: SystemCityItemInterface[];
}

export interface SystemCityMapItemInterface {
  [key: string | number]: SystemCityItemInterface;
}

export const systemCityAtom = atom<SystemCityItemInterface[]>({
  key: 'systemCity',
  default: []
});
export const systemCityMapAtom = atom<SystemCityMapItemInterface>({
  key: 'systemCityMap',
  default: {}
});
